import React from 'react';
import { useLocation } from '@/lib/browserRouter';

export const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};
